import { render, staticRenderFns } from "./ProductShortcut.vue?vue&type=template&id=42f21d42&scoped=true&"
import script from "./ProductShortcut.vue?vue&type=script&lang=js&"
export * from "./ProductShortcut.vue?vue&type=script&lang=js&"
import style0 from "./ProductShortcut.vue?vue&type=style&index=0&id=42f21d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f21d42",
  null
  
)

export default component.exports